import { groupTournamentsBySeason } from "./tournaments";
import { slugifyTournamentName } from "./slugify-tournament-name";
import { Tournament } from "@/types/tournament";

const SEASON_SEGMENT = /^s(\d+)$/;

type TournamentLike = Pick<Tournament, "name"> &
  Partial<Pick<Tournament, "season" | "startDate" | "endDate">>;

/** Season from the tournament itself, falling back to its date window. */
export function getTournamentSeason(
  tournament: TournamentLike
): number | null {
  if (tournament?.season) return tournament.season;
  if (!tournament?.startDate || !tournament?.endDate) return null;

  return groupTournamentsBySeason([tournament as Tournament])[0]?.season || null;
}

/** Route params for a tournament: `["s{n}", "{name-slug}"]`, or null if it has no season. */
export function getTournamentSlugSegments(tournament: TournamentLike) {
  const season = getTournamentSeason(tournament);
  if (!season) return null;

  return [`s${season}`, slugifyTournamentName(tournament?.name)];
}

/** Canonical tournament URL path: `/tournament/s{n}/{name-slug}`. */
export function getTournamentPath(tournament: TournamentLike): string {
  const segments = getTournamentSlugSegments(tournament);

  return segments ? `/tournament/${segments.join("/")}` : "/schedule";
}

/** Splits `[...slug]` into season (null = legacy URL), name slug and tab path. */
export function parseTournamentSlug(slug: string[] = []) {
  const match = slug[0]?.match(SEASON_SEGMENT);

  if (match) {
    return {
      season: Number(match[1]),
      nameSlug: slug[1],
      rest: slug.slice(2),
    };
  }

  return {
    season: null as number | null,
    nameSlug: slug[0],
    rest: slug.slice(1),
  };
}
